module.exports = "59d22201608a7487eb3833adfef44882.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/fog.png
// module id = 111
// module chunks = 0